import orderHistoryDateFilter from './orderHistoryFilters/orderHistoryDateFilter';
import OrderHistoryFilter from './orderHistoryFilters/OrderHistoryFilter';

const orderHistoryFilter = document.getElementById('orderHistoryFilter');
if (orderHistoryFilter) new OrderHistoryFilter();

const orderHistoryDateFilterForm = document.getElementById(
	'orderHistoryDateFilter',
);
if (orderHistoryDateFilterForm) orderHistoryDateFilter(window.od.OdSelect);
